/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./UserTable.css";
import RadixTable from "../../Component/RadixTable";
import PaginationBar from "../../Component/PaginationBar";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import {
  Text,
  Heading,
  Flex,
  Card,
  Tabs,
  TextField,
  Table,
} from "@radix-ui/themes";
import { getUserList } from "../../Services/DashboardApi";
import { GeneralContextFunc } from "../../Context/GeneralContex";
import { useNavigate } from "react-router-dom";

const header = ["Author", "Phone","email", "City"];

const UsersTable = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const { setloader, initAlert } = GeneralContextFunc();
  const [userRole, setUserRole] = useState("USER");
  const [userList, setUserList] = useState([]);
  const [cardDetails, setCardDetails] = useState({
    users: "",
    doners: "",
    admins: "",
  });
  const itemsPerPage = 10;
  const totalItems = userList.length; // Example total items
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    let payload = {
      page: 1,
      limit: itemsPerPage,
      body: { userType: userRole },
    };
    getData(payload);
  };

  const getData = (payload) => {
    getUserList(payload)
      .then((res) => {
        console.log("res", res);
        // initAlert(res?.message);
        setCardDetails({
          users: res?.data?.users,
          doners: res?.data?.donors,
          admins: res?.data?.admins,
        });
        let data = [...res?.data?.userData];
        setUserList([
          ...data.map((elem) => ({
            id: elem?.id,
            cellData: [
              elem?.firstName + " " + elem?.lastName,
              elem?.phone,
              elem?.email,
              elem?.location?.city || "",
            ],
          })),
        ]);
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        console.log("error", err);
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    setloader(true);
    setCurrentPage(1);
    let payload = {
      page: 1,
      limit: itemsPerPage,
      body: { userType: userRole },
    };
    getData(payload);
  }, [userRole]);

  // const tableBodyData = userList.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );
  console.log("userList", userList);
  const tableBodyData = userList;
  return (
    <>
      <Heading align="left" size="8" ml="5" mt="5">
        Users
      </Heading>
      <Flex ml="5" mt="5" className="flexCards">
        <Card>
          <Text as="div" size="3" weight="regular">
            Users
          </Text>
          <Text as="div" size="6" weight="bold">
            {cardDetails.users}
          </Text>
        </Card>
        <Card>
          <Text as="div" size="3" weight="regular">
            Admins
          </Text>
          <Text as="div" size="6" weight="bold">
            {cardDetails.admins}
          </Text>
        </Card>
      </Flex>
      <Tabs.Root value={userRole} mx="5" my="5">
        <Tabs.List className="tabList" color="gray" highContrast>
          <div style={{ display: "flex" }}>
            <Tabs.Trigger onClick={() => setUserRole("USER")} value="USER">
              Users
            </Tabs.Trigger>
            <Tabs.Trigger
              onClick={() => setUserRole("SUPERADMIN")}
              value="SUPERADMIN"
            >
              Admins
            </Tabs.Trigger>
          </div>
          <TextField.Root variant="soft" size="3" placeholder="Search">
            <TextField.Slot>
              <MagnifyingGlassIcon height="1.5rem" width="1.5rem" />
            </TextField.Slot>
          </TextField.Root>
        </Tabs.List>
      </Tabs.Root>
      <Table.Root variant="surface" size="3" mx="5" layout="auto">
        <RadixTable header={header} data={tableBodyData} routeUrl={"/"} />
      </Table.Root>
      {userList.length > 10 && (
        <PaginationBar
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default UsersTable;
